import React, { useEffect, useRef, useState } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';
import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, isEmpty, numberToWords, overLayers } from '../../utils/common';
import successImg from '../../assets/images/successimg.png';
const AepsReceipt = ({ closePop, transactionType ="g", bankDataResp }) => {
	const [customCss, setCustonCss] = useState({});
	const [zoom, setZoom] = useState("zoom-0");
	const heightCss = {
		height: '150px',
	};


	const handleDownloadClick = (title) => {
		setCustonCss({ height: 'auto' });
		setTimeout(() => {
			const divElement = document.getElementById('model');
			downloadDivAsImage(divElement, title, setCustonCss, heightCss);
		});
	};

	const handleCopy = (e, value) => {
		let target = e.target;

		navigator.clipboard
			.writeText(value)
			.then(() => {
				target.classList.add('active');

				(function (param) {
					setTimeout(() => {
						param.classList.remove('active');
					}, 1500);
				})(target);
			})
			.catch((err) => {
				console.error('Failed to copy text:', err);
			});
	};
	useEffect(() =>{
		setZoom("zoom-1");
		   },[]);
	   
		   const close = () =>{
			   setZoom("zoom-0");
			   setTimeout(() =>{
				   closePop();
			   },300)
		   }


	const regExpDebit = /^D/i;
	
		const boxRef = useRef(null);
		useEffect(() =>{
			overLayers(true);
			clickOutside(true,boxRef,close);
		
			return(() =>{
				overLayers(false)
				clickOutside(false,boxRef,close);
			})
		
		},[]);
	
	return (
		<ModalWraper url={backgroundImg}>
		<div className={`modal modal-success modal-body-aeps ${zoom}`} id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					<div className="buttons">
						<button className="button-solid" style={{ marginRight: '8px' }} onClick={() => handleDownloadClick('send money receipt')}>
							Download
						</button>
						<button className="button-solid" onClick={() => window.print()}>
							Print
						</button>
					</div>
				</div>
				<div className="modal-close" onClick={close}>
					<IconClose />
				</div>
				
				{transactionType !== 'Withdrawal' && (
					<div className="text-center modal-title">
						<h2 className="transactionMsg">Current Account Balance</h2>
						<h3 className="amount">₹ {bankDataResp?.balanceAmount}</h3>
						<p className="amount-text">{numberToWords(bankDataResp?.balanceAmount)}</p>
					</div>
				)}

				{transactionType === 'Withdrawal' && (
					<div className="text-center modal-title">
						<h2 className="transactionMsg">Transaction Successful!</h2>
						<h3 className="amount">₹ {bankDataResp?.amount}</h3>
						<p className="amount-text">{numberToWords(bankDataResp?.amount)}</p>
					</div>
				)}

				<div className="modal-body ">
					<div className="txn-daital">
						<div className="flex justify-between txn-daital-h">
							<div>Send To</div>
							<div></div>
						</div>
						{transactionType === 'Withdrawal' && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right">
									<div>
										<span>Status</span>
									</div>
								</div>
								<div className="txn-desc-left">
									<div>
										<span>
											{(bankDataResp?.status === "SUCCESS")?<div className="detail-desc success">
												<img src={successImg} alt={"success"} />
												SUCCESS
											</div>
											:<div className="detail-desc fail">
											Fail
										</div>}
										</span>
									</div>
								</div>
							</div>
						)}
						{!isEmpty(bankDataResp?.bankName) &&<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Bank Name</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{bankDataResp?.bankName}</span>
								</div>
							</div>
						</div>}
						{!isEmpty(bankDataResp?.bankRRN) && !isEmpty(bankDataResp?.balanceAmount) &&<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Bank RRN</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{bankDataResp?.bankRRN}</span>
								</div>
							</div>
						</div>}
						{transactionType === 'Withdrawal' && <div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Balance</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>₹ {bankDataResp?.balanceAmount}</span>
								</div>
							</div>
						</div>}
					{!isEmpty(bankDataResp?.timestamp) &&	<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Date And Time</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span> {bankDataResp?.timestamp}</span>
								</div>
							</div>
						</div>}
					{!isEmpty(bankDataResp?.transaction_id) &&	<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Transaction ID</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{bankDataResp?.transaction_id}</span>
								</div>
							</div>
						</div>}
					{!isEmpty(bankDataResp?.externalRef) &&	<div className="flex justify-between txn-desc">
							<div className="txn-desc-right">
								<div>
									<span>Reference No</span>
								</div>
							</div>
							<div className="txn-desc-left">
								<div>
									<span>{bankDataResp?.externalRef}</span>
								</div>
							</div>
						</div>
						}
					</div>
					{bankDataResp?.miniStatement?.length > 0 && (
						<div className="MiniStatementList">
							<div className="flex justify-between txn-daital-h">
								<div>Mini Statemen</div>
								<div></div>
							</div>
							<div className="MiniStatement" style={customCss}>
								<table>
									<thead>
										<tr>
											<th>Particulars</th>
											<th>Date</th>
											 <th>Type</th>
											<th>amount</th>
										</tr>
									</thead>
									<tbody>
										{bankDataResp?.miniStatement.length > 0 &&
											bankDataResp?.miniStatement.map((val, index) => {
												return (
													<tr key={index}>
														<td>{val.narration}</td>
														<td>{val.date}</td>
														 <td>{(val.txnType[0]?.toUpperCase()==="D"?"Debit":"Credit")}</td> 
														<td className={regExpDebit.test(val.txnType) ? 'red' : 'green'}>
															{regExpDebit.test(val.txnType) ? '-' : '+'} ₹ {val.amount}
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							</div>
						</div>
					)}
				</div>
			</div>
		</ModalWraper>
	);
};

export default AepsReceipt;
